enum ErrorMessage {
  UNKNOWN = "An unknown error occurred.",
  NETWORK_ERROR = "Network error occurred. Please check your connection and try again.",
  NO_RESPONSE = "No response received from the server, please try again.",
}

export default ErrorMessage;
